import React from "react";
import { FileModel } from "@admin/domain/files/model/FileModel";
import { VideoJs } from "@admin/components/VideoJs";
import { makePath } from "@admin/utils/makePath";
import { useSetModalVideo } from "@admin/components/ModalVideo";

type Props = {
    file: FileModel;
};

export default function ShowFileLink({ file }: Props) {
    const setModalVideo = useSetModalVideo();

    if (file.preview_file) {
        return (
            <div
                className="link link-primary cursor-pointer"
                onClick={() =>
                    setModalVideo({
                        show: true,
                        body: <VideoJs source={makePath(file.path)} />,
                    })
                }
            >
                Посмотреть
            </div>
        );
    }

    return (
        <a className="link link-success" href={makePath(file.path)} target="_blank">
            Посмотреть
        </a>
    );
}
